import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { action, computed, autorun, observable } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import inject from 'helpers/inject'
import formField from 'helpers/formField'

import FormInput from 'components/forms/FormInput'
import Button from 'material-ui/Button'
import { CardActions, CardContent } from 'material-ui/Card'
import { Typography } from 'material-ui';
import AsyncButton from 'components/AsyncButton'

import RouterService from 'services/router'

import authorize from 'tasks/authorize'

import { PasswordRecoveryRoute } from 'routes/config'

import styles from 'styles/components/LogInForm'

@withStyles(styles)
@observer
export default class LogInForm extends Component {

  static contextTypes = {
    swipeableViews: PropTypes.object.isRequired,
  }

  router = inject(RouterService)

  @observable authError = ''

  fields = [

    formField({
      value: '',
      label: 'Адрес электронной почты',
      type: 'email',
      name: 'email',
      validations: {
        presence: true
      }
    }),

    formField({
      value: '',
      label: 'Пароль',
      type: 'password',
      name: 'password',
      validations: {
        presence: true
      }
    })

  ]

  @computed
  get hasErrors() {
    return this.fields.filter(field => field.hasErrors).length > 0
  }

  @computed
  get login() {
    return this.fields.find(field => field.name === 'email')
  }

  @computed
  get password() {
    return this.fields.find(field => field.name === 'password')
  }

  componentDidMount() {
    autorun(() => {
      this.fields.filter(field => field.hasErrors || this.authError);
      window.setTimeout(() => {
        this.context.swipeableViews.slideUpdateHeight();
      }, 100)
    })
  }

  render() {
    const { classes } = this.props

    return (
      <form noValidate onSubmit={ this.handleSubmit } className={ classes.root } >

        <CardContent className={ classes.content } >

          { this.fields.map(( field, index ) => (
            <FormInput
              field={ field }
              key={ index }
              TextFieldProps={{
                fullWidth: true,
                disabled: authorize.isRunning
              }}
            />
          ))}

          <Typography paragraph >
            <Button fullWidth onClick={ this.handleDemoClick } >
              Demo
            </Button>
          </Typography>

          { this.authError &&
            <Typography paragraph color='error'>
              { this.authError }
            </Typography>
          }

        </CardContent>

        <CardActions className={ classes.actions } >

          <Button onClick={ this.handleForgotPassword } fullWidth >
            Забыл пароль
          </Button>

          <AsyncButton
            action={ this.handleSubmit }
            label='Войти'
            processingLabel=''
            successLabel='Успешно!'
            ButtonProps={{
              fullWidth: true,
              raised: true,
              color: 'primary'
            }}
          />

        </CardActions>

      </form>
    )
  }

  @action.bound
  async handleSubmit() {
    if (!this.validateForm()) throw new Error()
    try {
      const result = await authorize.perform(this.login.value, this.password.value)
      if (result) this.router.transitionTo()
    } catch (error) {
      this.authError = "Неверный E-mail или пароль"
      throw error
    }
  }

  @action.bound
  handleForgotPassword() {
    this.router.transitionTo(PasswordRecoveryRoute)
  }

  @action.bound
  handleDemoClick() {
    this.login.value = 'user1@email.com'
    this.password.value = '123'
  }

  @action.bound
  validateForm() {
    this.authError = ''
    this.fields.forEach(field => field.validate())
    return !this.hasErrors
  }

}



// WEBPACK FOOTER //
// ./src/components/LogInForm.js